import { render, staticRenderFns } from "./EducatorForm.vue?vue&type=template&id=c34a6148&"
import script from "./EducatorForm.vue?vue&type=script&lang=js&"
export * from "./EducatorForm.vue?vue&type=script&lang=js&"
import style0 from "./EducatorForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports